var map = {
	"./arm-articulated-claw.png": "2a20",
	"./arm-dual-claw.png": "ec5f",
	"./arm-grabber.png": "bea8",
	"./arm-propeller.png": "d674",
	"./arm-stubby-claw.png": "357f",
	"./base-double-wheel.png": "66a9",
	"./base-rocket.png": "88be",
	"./base-single-wheel.png": "2938",
	"./base-spring.png": "e262",
	"./base-triple-wheel.png": "82f7",
	"./head-big-eye.png": "060a",
	"./head-friendly.png": "1da9",
	"./head-shredder.png": "33f7",
	"./head-single-eye.png": "8cdf",
	"./head-surveillance.png": "133e",
	"./torso-flexible-gauged.png": "d625",
	"./torso-gauged.png": "d718",
	"./torso-pouch.png": "0f71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c56a";